import { handleActions } from 'redux-actions';
import {
  FETCH_USER_INFO_PENDING,
  FETCH_USER_INFO_SUCCESS,
  FETCH_USER_INFO_ERROR,    
} from '../actions/me';


const defaultState = { data: localStorage.getItem('userProfilePictureThumbnail'), loading: false };

export default handleActions({
  [FETCH_USER_INFO_PENDING]: (state, action) => {
    return {
      data: undefined,
      loading: true,
      cancelTokenSource: action.payload.cancelTokenSource
    };
  },
  [FETCH_USER_INFO_SUCCESS]: (state, action) => {
    return {
      data: action.payload,
      loading: false,
      cancelTokenSource: null
    };
  },
  [FETCH_USER_INFO_ERROR]: (state, action) => {
    return {
      data: undefined,
      loading: false,
      error: action.payload,
      cancelTokenSource: null
    };
  }
}, defaultState)